
//
export default [
    {
        name: 'flag_viewed',
        props: {
            chips: false,
            itemText: 'text',
            itemValue: 'id',
            label: 'Visto',
            items: [
              {id:true , text:'Si'},
              {id:false, text:'No'}
            ],
            noObject: true,
        },
        type: 'autocomplete',
    },
    {
      name: 'flag_notification_from_sale',
      props: {
          chips: false,
          itemText: 'text',
          itemValue: 'id',
          label: 'Vendedor Terreno',
          items: [
            {id:true , text:'Si'},
            {id:false, text:'No'}
          ],
          noObject: true,
      },
      type: 'autocomplete',
  },
    // {
    //     name: 'of_warehouse',
    //     props: {
    //         chips: true,
    //         itemText: 'name',
    //         itemValue: 'id',
    //         label: 'Bodega',
    //         model: MdlWarehouse,
    //         noObject: true,
    //     },
    //     type: 'autocomplete-model',
    // },
    // {
    //     name: 'name',
    //     props: {
    //         label: 'Nombre',
    //     },
    //     type: 'text-field',
    //     value: '',
    // },
    // {
    //     name: 'alias_name',
    //     props: {
    //         label: 'Alias',
    //     },
    //     type: 'text-field',
    //     value: '',
    // },
    // {
    //     name: 'internal_code',
    //     props: {
    //         label: 'Código Interno',
    //     },
    //     type: 'text-field',
    //     value: '',
    // },
    // {
    //     name: 'wh_family_id',
    //     props: {
    //         chips: true,
    //         itemText: 'family',
    //         itemValue: 'id',
    //         label: 'Familia',
    //         model: MdlFamily,
    //         noObject: true,
    //     },
    //     type: 'autocomplete-model',
    // },
    // {
    //     name: 'wh_subfamily_id',
    //     props: {
    //         chips: true,
    //         itemText: 'subfamily',
    //         itemValue: 'id',
    //         label: 'Sub Familia',
    //         model: MdlSubFamily,
    //         noObject: true,
    //         paramSearch: 'subfamily',
    //     },
    //     type: 'autocomplete-model',
    // },
]
